<div [ngClass]="section === 'detail' ? 'offers-detail' : 'offers-results'">
  <p class="offer-text oustanding-promo">
    <mb-icon class="icon" [icon]="offer.icon"></mb-icon
    ><span class="text">{{ offer.name }}</span>
  </p>
</div>
